export class Headbalanceallocation {
  id: number;
  enterpriseId: number;
  quantity: number;
  balance: number;
  lastUpdateAt: string;
  createAt: string;
  active: number;
}
